import { Checkbox, DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriverExpirationDateReport extends Layout {
    checkHM126: Checkbox;
    checkMVRDate: Checkbox;
    checkboxDriverLicense: Checkbox;
    checkboxHazMat: Checkbox;
    checkboxIncludeNullDates: Checkbox;
    checkboxMedicalCertificate: Checkbox;
    checkboxPageBreak: Checkbox;
    checkboxPhysicalDue: Checkbox;
    checkboxSecurityAwareness: Checkbox;
    excludabletextboxDRIVERMGR: ExcludableTextbox;
    excludabletextboxDriverMgr: ExcludableTextbox;
    excludabletextboxFleets: ExcludableTextbox;
    sourceDriverExpirationDateReport: DataSource;
    textboxExpiringIn: Textbox;
    textboxGroupBy: Textbox;
}
